<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>บริการ
          <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(lang)=='en'"></span>
          <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(lang)" v-if="covertoLowerCase(lang)!='en'"></span>
        </b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'ServiceAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
      </ul>
    </nav>
    <div v-for="valueService in data.services" class="card col-md-12" :key="valueService.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4">
            <img v-bind:src="valueService.image" @error="imageLoadError" class="d-block w-full">
          </div>
          <div class="col-sm-12 col-lg-8">
            <div id="spy-example2" data-spy="scroll" data-target="#list-example" data-offset="0">
              <h4 class="text-center">
                <b v-html="valueService.title"></b>
              </h4>
              <label v-if="valueService.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ valueService.created_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <label v-if="valueService.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ valueService.updated_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <div class="col-sm-12" v-if="valueService.description!=''" style="overflow: hidden">
                <p>
                  <span v-html="valueService.description"></span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="col-sm-12 col-lg-12 row">
              <div class="col-sm-12 col-lg-4">
                <div class="col-sm-12 col-lg-12 row">
                  <div class="ml-4" v-for="valueLang of valueService.languages" :key="valueLang">
                    <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-us'" v-if="covertoLowerCase(valueLang)=='en'"></span>
                    <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-'+covertoLowerCase(valueLang)"
                      v-if="covertoLowerCase(valueLang)!='en'"></span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-lg-8">
                <div class="row">
                  <div class="col-lg-4 col-sm-4">

                    <a target="_blank" style="text-decoration: none" v-bind:href="site_url.src+'services/'+valueService.slug+'-'+valueService.id">
                      <b-btn class="mt-3" variant="outline-primary" block><i class="fas fa-eye"></i> แสดงตัวอย่าง</b-btn>
                    </a>

                    <!--<b-btn @click="$router.push({ name: 'ServiceByID',params: { slug: valueService.slug},query: { id: valueService.id }})"
                        class="mt-3" variant="outline-primary" block><i class="fas fa-eye"></i> แสดงตัวอย่าง</b-btn>-->

                  </div>
                  <div class="col-lg-4 col-sm-4">
                    <b-btn @click="$router.push({ name: 'ServiceEdit',params: { id: valueService.id }})" class="mt-3"
                      variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
                  </div>
                  <div class="col-lg-4 col-sm-4">
                    <b-btn @click="alertDeleteService(valueService.id,valueService.title)" class="mt-3" variant="outline-primary"
                      block><i class="fas fa-trash-alt"></i> ลบ</b-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="service.alert.title" ref="alert" hide-footer v-model="service.alert.active" @ok="service.alert.active = false">
      <div v-if="service.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="service.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="service.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="service.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="service.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="service.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="service.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="service.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <div v-if="data.per_page&&data.per_page!=null&&data.per_page>1" class="w-full">
      <b-pagination align="center" :total-rows="data.per_page*data.per_page" v-on:input="getServices" v-model="data.page"
        :per-page="data.per_page"></b-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        site_url:{
          src: localStorage.getItem('z_site_url')
        },
        no_image: {
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        service: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            image: null,
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        category_id: this.$route.query.category_id,
        lang: this.$route.query.lang,
        authorization: 'Bearer ' + localStorage.getItem('z_token'),
        data: {
          page: this.$route.query.page,
          per_page: null,
          services: {}
        }
      }
    },
    mounted() {
      if (this.lang) {
        this.lang = this.lang
      }
      this.checkLang()
      this.startLoad(1)
      this.getServices()
      this.checkLoad()
    },
    methods: {
      covertoLowerCase(title) {
        if (title && title != '') {
          return title.toLowerCase()
        } else {
          return title
        }
      },
      checkLang() {
        if (!this.lang) {
          this.lang = 'th'
        }
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeleteService(serviceID, serviceName) {
        this.service.id = serviceID
        this.service.name = serviceName
        this.service.alert.title = 'การลบบริการ'
        this.service.alert.detail = 'คุณต้องการลบบริการ "<b>' + serviceName + '</b>" ใช่หรือไม่?'
        this.service.alert.open.active = true
        this.service.alert.close.active = true
        this.service.alert.open.name = 'ยืนยันการลบ'
        this.service.alert.close.name = 'ยกเลิกการลบ'
        this.service.alert.active = true
      },
      submitDelete() {
        this.service.alert.load = true
        this.deleteServiceByID()
      },
      getServices() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/services', {
          params: {
            page: this.data.page,
            per_page: this.data.per_page,
            category_id: this.category_id,
            lang: this.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.lang = response.data.json.lang
          this.checkLoad()
          moment.locale(this.lang)
          this.data.page = parseInt(response.data.json.page)
          this.data.per_page = parseInt(response.data.json.per_page)
          if (this.category_id != null) {
            this.$router.replace({
              name: 'ServicesList',
              query: {
                category_id: this.category_id,
                page: this.data.page,
                lang: this.lang
              }
            })
          } else {
            this.$router.replace({
              name: 'ServicesList',
              query: {
                page: this.data.page,
                lang: this.lang
              }
            })
          }
          this.data.services = response.data.json.data
        }).catch(function (error) {
          this.failLoad()
          this.service.alert.title = 'การดึงข้อมูลบริการ'
          this.service.alert.detail = 'ไม่สามารถทำการดึงบริการได้!'
          this.service.alert.open.active = false
          this.service.alert.close.name = 'ปิด'
          this.service.alert.active = true
        })
      },
      deleteServiceByID() {
        if (this.service.id && this.service.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/service/' + this.service.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.service.alert.load = false
            this.getServices()
            this.service.alert.detail = 'ทำการลบบริการหมายเลข: ' + response.body.json.service.id + ' เรียบร้อย'
            this.service.alert.open.active = false
            this.service.alert.close.name = 'ปิด'
            this.service.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.service.alert.detail = 'ไม่สามารถทำการลบบริการได้!'
            this.service.alert.open.active = false
            this.service.alert.close.name = 'ปิด'
            this.service.alert.active = true
          })
        }
      },
      imageLoadError(event) {
        event.target.src = this.no_image.src
      }
    }
  }

</script>
